angular.
module("dx.webapp.droparea").
controller("DxUploadareaController", function UploadareaController(
	$document,
	$scope,
	$cookies,

	DX_UPLOAD_STATE,

	FileUploader
) {
	"use strict";

	var self = this;
	self.invalidFiles = [];

	var requestHeaders = {};
	requestHeaders["X-CSRF-Token"] = $cookies.get("csrf");

	self.uploader = new FileUploader({
		url: self.uploadUrl,
		headers: requestHeaders,
	});

	$scope.$watch("vm.uploadUrl", function uploadUrlUpdated() {
		self.uploader.url = self.uploadUrl;
	});

	if (self.maxFiles) {
		self.uploader.queueLimit = self.maxFiles;
	}

	var body = $document.find("body");
	var fileDrop = new FileUploader.FileDrop({
		uploader: self.uploader,
		element: body,
	});

	if (!self.control) {
		self.control = {};
	}

	self.control.state = DX_UPLOAD_STATE.INITIAL;
	self.control.upload = function upload() {
		self.control.state = DX_UPLOAD_STATE.UPLOADING;
		self.uploader.uploadAll();
	};
	self.control.disableFileAdd = destroyFileDrop;
	self.control.reset = function reset() {
		self.control.state = DX_UPLOAD_STATE.INITIAL;
		self.uploader.clearQueue();
	};

	self.uploader.filters.push({
		name: "extensionTest",
		fn: function fn(item) {
			var nameParts = item.name.split(".");
			var extension = nameParts[nameParts.length - 1];

			var validExtension = false;

			for (var i = 0; i < self.fileExtensions.length; i++) {
				if (extension === self.fileExtensions[i]) {
					validExtension = true;
					break;
				}
			}

			return validExtension;
		},
	});

	self.uploader.filters.push({
		name: "denyAfterUploadStart",
		fn: function fn() {
			return self.uploader.progress === 0 || self.uploader.queue.length === 0;
		},
	});

	self.isDisabled = function isDisabled() {
		return self.uploader.queue.length >= self.maxFiles;
	};

	self.uploader.onAfterAddingFile = function onAfterAddingFile() {
		self.control.state = DX_UPLOAD_STATE.UPLOAD_PENDING;
	};

	self.uploader.onWhenAddingFileFailed = function onWhenAddingFileFailed(item, filter) {
		if (filter.name === "extensionTest") {
			self.invalidFiles.push(item);
		}
	};

	self.uploader.onBeforeUploadItem = function onBeforeUploadItem(item) {
		item.formData = [self.control.formData];
	};

	self.uploader.onCompleteItem = function onCompleteItem(item, response, status) {
		if (item.isError) {
			item.errorMessage = "UploadFailed";
		}

		if (self.onFileUploaded) {
			self.onFileUploaded(item, response, status);
		}
	};

	self.uploader.onCompleteAll = function onCompleteAll() {
		self.control.state = DX_UPLOAD_STATE.UPLOAD_COMPLETE;

		if (self.onCompleteAll) {
			self.onCompleteAll();
		}
	};

	self.removeItemClicked = function removeItemClicked($event, item) {
		item.remove();

		if (self.uploader.getNotUploadedItems().length === 0) {
			self.control.state = DX_UPLOAD_STATE.INITIAL;
		}

		$event.stopPropagation();
	};

	$scope.$on("$destroy", function onDestroy() {
		destroyFileDrop();
	});

	function destroyFileDrop() {
		fileDrop.destroy();

		// Event unbinding is bugged in angular-file-upload, so we need to do it properly
		// ourselves. See https://github.com/nervgh/angular-file-upload/issues/759
		for (var key in fileDrop.events) {
			if (fileDrop.events.hasOwnProperty(key)) {
				var prop = fileDrop.events[key];
				fileDrop.element.unbind(key, fileDrop[prop]);
			}
		}
	}
});
